import { render, staticRenderFns } from "./SliderVertical.vue?vue&type=template&id=63e24381"
import script from "./SliderVertical.vue?vue&type=script&lang=js"
export * from "./SliderVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports